import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { useHistory } from 'react-router';
import styles from './Wrapper.module.scss';

export interface Props extends Partial<React.HTMLAttributes<HTMLDivElement>> {
  contentProps?: React.HTMLAttributes<HTMLDivElement>;
  isFullScreen?: boolean;
  itemRef?: any;
  subHeader?: {
    title: string;
    showBack?: boolean;
    onClose?: () => void;
    left?: ReactNode;
    right?: ReactNode;
    props?: React.HTMLAttributes<HTMLDivElement>;
  };
}

export default function Wrapper({
  subHeader,
  contentProps,
  isFullScreen,
  itemRef,
  ...props
}: Props) {
  const history = useHistory();

  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <div
      {...props}
      ref={itemRef}
      className={clsx(
        styles.container,
        props.className,
        subHeader && styles.withSubHeader,
        isFullScreen && styles.isFullScreen
      )}
    >
      {subHeader && (
        <div
          {...subHeader.props}
          className={clsx(styles.subHeader, subHeader.props?.className)}
        >
          <div className={styles.subHeaderContent}>
            {subHeader.showBack && (
              <button
                className={styles.subHeaderBackBtn}
                onClick={handleBackClick}
              >
                <i className="fonticons fonticons-arrow-left" />
              </button>
            )}
            {subHeader.onClose && (
              <button
                className={styles.subHeaderCloseBtn}
                onClick={subHeader.onClose}
              >
                <i className="fonticons fonticons-x" />
              </button>
            )}

            <h2 className={styles.subHeaderTitle}>{subHeader.title}</h2>

            {subHeader.left && subHeader.right && (
              <div className={styles.subHeaderLeftRightContainer}>
                <div className={styles.subHeaderLeft}>{subHeader.left}</div>
                <div className={styles.subHeaderRight}>{subHeader.right}</div>
              </div>
            )}
          </div>
        </div>
      )}

      <div
        {...contentProps}
        className={clsx(styles.content, contentProps?.className)}
      >
        {props.children}
      </div>
    </div>
  );
}
